import { useEffect } from 'react'
import thinkingdata from 'thinkingdata-browser'
import huanledata from 'huanledata-browser'
import message from '@/pages/hmt/reservation/official-site/components/message'
import { get } from '@/pages/sea/utils/fetch'
import { getCookie } from '@/utils/cookie'
import { isPC } from '@/utils'
import { useMemoizedFn } from 'ahooks'

// 创建 SDK 配置对象
const taConfig = {
  appId: 'd24cc03bccb14899a55ade9feaf9ee45',
  serverUrl: 'https://ta-report-lna.roglobal.com/sync_js',
}

const huanleConfig = {
  appId: 'roo-official_lna',
  serverUrl: 'https://tc-bigdata-agent.huanle.com/sync_js',
}

const formatQuery = (): Record<string, string> => {
  const params = new URLSearchParams(window.location.search);
  const result: Record<string, string> = {};
  const keyPattern = /^[a-z#][a-z0-9_]*$/;

  params.forEach((value, key) => {
    if (keyPattern.test(key)) {
      result[key] = value;
    }
  });

  return result;
};

const searchParams = new URLSearchParams(
  decodeURIComponent(window.location.search)
)

const getPathnameLastTwoPath = () => {
  const path = window.location.pathname
    .split('/')
    .slice(-2)
    .filter((item) => item)
    .join('/')
  return `/${path}`
}

const getClient = () => {
  let client = 'PC'
  if (!isPC()) {
    const ua = navigator.userAgent.toLocaleLowerCase()
    const isIOS = /(iphone|ipad|ipod|ios)/i.test(ua)
    if (isIOS) {
      client = 'IOS'
    } else {
      client = 'Android'
    }
  }
  return client
}

const getGclid = () => {
  return (
    searchParams.get('external_click_id') ||
    getCookie('external_click_id') ||
    getCookie('gclid') ||
    ''
  )
}

export enum EventType {
  PcPageview = 'pcPageview',
  PcDownload = 'pcDownload',
  ApkDownload = 'apkDownload',
  AppStoreDownload = 'appStoreDownload',
  GooglePlayDownload = 'googlePlayDownload',
  HuaweiDownload = 'huaweiDownload',
  // 十人本埋点
  PageOpen = 'PageOpen',
  Login = 'Login',
  TeamCreate = 'TeamCreate',
  TeamJoin = 'TeamJoin',
  TeamQuit = 'TeamQuit',
  TeamDismiss = 'TeamDismiss',
  TeamRemove = 'TeamRemove',
}

/**
 * 用于从广告落地页跳转到官网，进行数据上报
 * 跳转过来 url 携带的关键字：{lpurl}?campaign={campaignid}&adgroup={adgroupid}&creative={keyword}_{matchtype}&external_click_id={gclid}
 */
const useTA = <T = EventType>() => {
  const ta = thinkingdata

  const hl = huanledata

  useEffect(() => {
    ta?.init(taConfig)
  }, [ta])

  useEffect(() => {
    hl?.init(huanleConfig)
  }, [hl])

  const reportTrack = (
    event: T,
    btn?: string,
    extra?: Record<string, string>
  ) => {
    const btnInfo = btn ? { btnName: btn } : {}

    ta.track(event as string, {
      page: getPathnameLastTwoPath() ?? 'cover-page', //
      env: import.meta.env.MODE, //
      client: getClient(), //
      gclid: getGclid(), //
      ...formatQuery(), //
      ...btnInfo, //
      ...extra,
    })

    hl.track(event as string, {
      page: getPathnameLastTwoPath() ?? 'cover-page',
      env: import.meta.env.MODE,
      client: getClient(),
      gclid: getGclid(),
      ...formatQuery(),
      ...btnInfo,
      ...extra,
    })
  }

  const reportTrackMemo = useMemoizedFn(
    (event: T, btn?: string, extra?: Record<string, string>) => {
      const btnInfo = btn ? { btnName: btn } : {}
      ta.track(event, {
        page: getPathnameLastTwoPath() ?? 'cover-page',
        env: import.meta.env.MODE,
        client: getClient(),
        gclid: getGclid(),
        ...formatQuery(),
        ...btnInfo,
        ...extra,
      })

      hl.track(event as string, {
        page: getPathnameLastTwoPath() ?? 'cover-page',
        env: import.meta.env.MODE,
        client: getClient(),
        gclid: getGclid(),
        ...formatQuery(),
        ...btnInfo,
        ...extra,
      })
    }
  )

  /**
   * 用于判断是否是从广告跳转过来的
   */
  const isFromAd = () => !!searchParams.get('campaign')

  const downloadWindowsLauncher = async () => {
    try {
      const resp = await get(`/api/download/pc-launcher?gclid=${getGclid()}`)
      if (resp.data?.url) {
        window.open(resp.data.url)
        reportTrack(EventType.PcDownload as any)
      } else {
        message.info({
          content: 'Coming Soon',
        })
      }
    } catch (error) {
      console.error(error)
      message.info({
        content: 'Coming Soon',
      })
    }
  }

  return {
    initTa: () => {
      thinkingdata.init(taConfig)
      huanledata.init(huanleConfig)
    }, // 用配置对象初始化 SDK
    // isFromAd,
    reportTrack,
    reportTrackMemo,
    downloadWindowsLauncher,
  }
}

export default useTA
